import { Product } from '../../../catalog/products/product';

export class ServiceBase extends Product {}
